export default __webpack_public_path__ + "static/media/tag_icon.e6c884ff.svg";